import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { JYoguiSchoolModule } from './school/school.module';
import { JYoguiStudentModule } from './student/student.module';
import { JYoguiStudentCommentModule } from './student-comment/student-comment.module';
import { JYoguiLocationModule } from './location/location.module';
import { JYoguiCountryModule } from './country/country.module';
import { JYoguiCityModule } from './city/city.module';
import { JYoguiTaxModule } from './tax/tax.module';
import { JYoguiCardTypeModule } from './card-type/card-type.module';
import { JYoguiCatalogModule } from './catalog/catalog.module';
import { JYoguiSubscriptionTypeModule } from './subscription-type/subscription-type.module';
import { JYoguiClassTypeModule } from './class-type/class-type.module';
import { JYoguiEnrollmentModule } from './enrollment/enrollment.module';
import { JYoguiCardModule } from './card/card.module';
import { JYoguiLessonModule } from './lesson/lesson.module';
import { JYoguiReservationCancellationReasonModule } from './reservation-cancellation-reason/reservation-cancellation-reason.module';
import { JYoguiReservationModule } from './reservation/reservation.module';
import { JYoguiReservationPriorityModule } from './reservation-priority/reservation-priority.module';
import { JYoguiUnavailableDateModule } from './unavailable-date/unavailable-date.module';
import { JYoguiSchoolCalendarModule } from './school-calendar/school-calendar.module';
import { JYoguiPaymentModule } from './payment/payment.module';
import { JYoguiPaymentItemModule } from './payment-item/payment-item.module';
import { JYoguiNewsArticleModule } from './news-article/news-article.module';
import { JYoguiLegalNoticeModule } from './legal-notice/legal-notice.module';
import { JYoguiInvoiceModule } from './invoice/invoice.module';
import { JYoguiInvoiceItemModule } from './invoice-item/invoice-item.module';
import { JYoguiEventModule } from './event/event.module';
import { JYoguiEventReservationModule } from './event-reservation/event-reservation.module';
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */

@NgModule({
    imports: [
        JYoguiSchoolModule,
        JYoguiStudentModule,
        JYoguiStudentCommentModule,
        JYoguiLocationModule,
        JYoguiCountryModule,
        JYoguiCityModule,
        JYoguiTaxModule,
        JYoguiCardTypeModule,
        JYoguiCatalogModule,
        JYoguiSubscriptionTypeModule,
        JYoguiClassTypeModule,
        JYoguiEnrollmentModule,
        JYoguiCardModule,
        JYoguiLessonModule,
        JYoguiReservationCancellationReasonModule,
        JYoguiReservationModule,
        JYoguiReservationPriorityModule,
        JYoguiUnavailableDateModule,
        JYoguiSchoolCalendarModule,
        JYoguiPaymentModule,
        JYoguiPaymentItemModule,
        JYoguiNewsArticleModule,
        JYoguiLegalNoticeModule,
        JYoguiInvoiceModule,
        JYoguiInvoiceItemModule,
        JYoguiEventModule,
        JYoguiEventReservationModule
        /* jhipster-needle-add-entity-module - JHipster will add entity modules here */
    ],
    declarations: [],
    entryComponents: [],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiEntityModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity.module.ts